"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineDealerSearchService = void 0;
const v1_1 = require("./v1");
const v2_1 = require("./v2");
const v3_1 = require("./v3");
__exportStar(require("./types"), exports);
__exportStar(require("./v1/types"), exports);
__exportStar(require("./v2/types"), exports);
__exportStar(require("./v3/types"), exports);
function defineDealerSearchService() {
    return {
        id: 'dealer-search-service',
        optionalDependencies: {
            featureServices: {
                's2:logger': '^1.0.0',
                'gfa:dealer-context-service': '^1.0.0',
            },
        },
        create: ({ featureServices }) => {
            const { 's2:logger': logger = console, 'gfa:dealer-context-service': dealerContextService, } = featureServices;
            const v3 = new v3_1.DealerSearchServiceV3Impl(dealerContextService);
            const v2 = new v2_1.DealerSearchServiceV2Proxy(logger, v3);
            return {
                '1.1.0': (consumerID) => ({
                    featureService: new v1_1.DealerSearchServiceV1Proxy(consumerID, v2),
                }),
                '2.0.1': () => ({
                    featureService: v2,
                }),
                '3.0.0': () => ({
                    featureService: v3,
                }),
            };
        },
    };
}
exports.defineDealerSearchService = defineDealerSearchService;
//# sourceMappingURL=index.js.map